import styled, { css } from 'styled-components';

const itemListStyles = css`
display: flex;
flex-direction:column;
&.empty {
  border:none;
}
& .item {
  border: 1px solid #cccccc;
  border-top: none;
  &:last-child {
    border-top: none;
  }
  &:first-child {
    border-top: 1px solid #cccccc;
  }
}
& .none {
  width: 100%;
  text-align:center;
  font-style: italic;
}
`;

const ItemList = styled(({ className, emptyText = 'No items in list', items, component: ItemComponent, onSelectItem }) => {
  const listItems = items.length > 0
    ? items.map((item, i) => <ItemComponent key={i} className='item' item={item} onSelectItem={onSelectItem}/>)
    : <div className='none'>{emptyText}</div>
  return (
    <div className={className}>
      {listItems}
    </div>
  )
})`${itemListStyles}`;

export default ItemList;